const User = {

    // FIELDS
    "role": "Role",
    "fname": "First Name",
    "lname": "Last Name",
    "gender": "Gender",
    "username": "Username",
    "password": "Password",
    "confirm_password": "Confirm Password",
    "mobile": "Mobile Number",
    "email": "Email",
    "profile": "Profile Photo",
    "dob": "Date of Birth",
    "status": "Status",

    // PAGE HEADER
    "user": "User",
    "search": "Search",

    // TABLE HEADERS
    "table_name": "NAME",
    "table_username": "USERNAME",
    "table_email": "EMAIL",
    "table_mobile": "MOBILE",
    "table_role": "ROLE",
    "table_gender": "GENDER",
    "table_status": "STATUS",

    // ERROR MESSAGES
    "error_role": "Select Role",
    "error_fname": "Enter First Name",
    "error_lname": "Enter Last Name",
    "error_gender": "Select Gender",
    "error_username": "Enter Username",
    "error_password": "Enter Password",
    "error_confirm_password": "Enter Confirm Password",
    "error_password_match": "Confirm Password doesn't match",
    "error_mobile": "Enter Mobile Number",
    "error_invalid_mobile": "Invalid Mobile Number (10 digits required)",
    "error_email": "Enter Email",
    "error_invalid_email": "Invalid Email Address",
    "error_file_size": "File size must be less than 5MB",
    "error_file_type": "Only JPG, JPEG, PNG images are allowed",
    "error_dob": "Select Date of Birth",
    "error_status": "Select Status",

}

export default User;